(function () {
  var banners = document.querySelectorAll('[data-aom-savings-banner]');
  if (!banners.length) return;

  var variantsEl = document.getElementById('product-variants-json');
  if (!variantsEl) return;

  var variants = JSON.parse(variantsEl.textContent || '[]');

  function formatMoney(cents) {
    var s = window.Shopify;
    return new Intl.NumberFormat(
      (s && s.locale) || 'en',
      { style: 'currency', currency: (s && s.currency && s.currency.active) || 'USD' }
    ).format(cents / 100);
  }

  function updateBanners(variant) {
    if (!variant) return;
    var saveCents = Math.max(0, Number(variant.compare_at_price || 0) - Number(variant.price || 0));
    var formatted = formatMoney(saveCents);
    banners.forEach(function (banner) {
      banner.querySelectorAll('[data-aom-savings-amount]').forEach(function (el) {
        el.textContent = formatted;
      });
    });
  }

  function findVariantByOptions(options) {
    return variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === options[i]; });
    });
  }

  function getSelectedOptions(picker) {
    // variant-selects: one <select> per option
    var selects = picker.querySelectorAll('select');
    if (selects.length) {
      return Array.from(selects).map(function (s) { return s.value; });
    }
    // variant-radios: one checked radio per option group (grouped by name)
    var groups = {};
    picker.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
      groups[r.name] = r.value;
    });
    return Object.values(groups);
  }

  // React to bundle tier selection (dispatched by bundle.js)
  document.addEventListener('aom:savings', function (e) {
    var formatted = formatMoney(e.detail.saveCents);
    banners.forEach(function (banner) {
      banner.querySelectorAll('[data-aom-savings-amount]').forEach(function (el) {
        el.textContent = formatted;
      });
    });
  });

  // React to Dawn's native variant-selects / variant-radios elements
  document.addEventListener('change', function (e) {
    // Ignore AOM bundle widget selects — they have their own price sync
    if (e.target.closest('.aom-discount-wrapper')) return;

    var picker = e.target.closest('variant-selects, variant-radios');
    if (!picker) return;

    var options = getSelectedOptions(picker);
    if (options.length) updateBanners(findVariantByOptions(options));
  });
})();
